import { FC } from 'react'
import cn from 'classnames'
import { getWazzupChannelTypeLabel } from './wazzupCrmIntegration.helpers'
import { getWazzupChannelTypeVisual } from './wazzupChannelTypeVisual'
import classes from './wazzupChannelTypeMark.module.css'

type WazzupChannelTypeMarkSize = 'sm' | 'md' | 'lg'

type WazzupChannelTypeMarkProps = {
  type?: string | null
  size?: WazzupChannelTypeMarkSize
  className?: string
}

/** Для aria / tooltip: «Wazzup, Telegram API». */
export const formatWazzupChannelAriaLabel = (
  type?: string | null,
): string => {
  const typeLabel = getWazzupChannelTypeLabel(String(type ?? ''))
  if (!typeLabel || typeLabel === 'неизвестный') {
    return 'Wazzup'
  }
  return `Wazzup, ${typeLabel}`
}

/** @deprecated используй formatWazzupChannelAriaLabel или подпись типа канала */
export const formatWazzupChannelSourceLabel = formatWazzupChannelAriaLabel

/** Только иконка типа канала (TG / WA / …) — без второго бейджа. */
export const WazzupChannelTypeMark: FC<WazzupChannelTypeMarkProps> = ({
  type,
  size = 'md',
  className,
}) => {
  const visual = getWazzupChannelTypeVisual(type)
  const { Icon, accentColor, isBrandMark } = visual

  return (
    <span
      className={cn(
        classes.mark,
        classes[`mark_${size}`],
        isBrandMark && classes.mark_brand,
        className,
      )}
      style={{ color: accentColor }}
      aria-hidden
    >
      <Icon className={cn(classes.icon, isBrandMark && classes.icon_brand)} />
    </span>
  )
}

export default WazzupChannelTypeMark
